import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import TableWrapper from 'components/table/TableWrapper';

import { instance } from 'api/axios.instance';

// 실태 조사 관리
export default function RealSurvey() {
  const boardType = 'realSurvey';

  // hooks
  const [searchParams] = useSearchParams();

  // state
  const [fetchData, setFetchData] = useState({ list: [], pagination: {} }); // 실태 조사 목록
  const [loading, setLoading] = useState(false); // 로딩 상태

  // 테이블 헤더 (테이블 내 형식 및 이벤트 관리)
  const tableHeader = [
    // { label: '선택', key: 'checkbox', width: '64px' },
    { label: '번호', key: 'index', width: '64px' },
    { label: '년도', key: 'year', width: '120px' },
    { label: '지역', key: 'region', width: '120px' },
    { label: '제목', key: 'title', width: 'auto', left: true, className: 'has-detail', code: 'year' },
    { label: '등록일', key: 'createDate', width: '120px' }
  ];

  // 실태 조사 목록 조회 API
  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const searchTypeMap = {
        연도: 'year',
        지역: 'region'
      };

      const response = await instance('/statistic/list', {
        method: 'POST',
        data: {
          pageNo: Number(searchParams.get('page')) || 1, // 페이지 번호
          searchType: searchTypeMap[searchParams.get('searchType')] || '', // 검색 카테고리
          search: searchParams.get('search') || '', // 검색어
          region: searchParams.get('region') || 'ALL' // 지역
        }
      });
      setFetchData({ pagination: response.data.data.pagination, list: response.data.data.statistics });
    } finally {
      setLoading(false);
    }
  }, [searchParams]);

  // mount 및 searchParams 변경 시 호출
  useEffect(() => {
    fetchList();
  }, [fetchList, searchParams]);

  return (
    <Section>
      <PageTitle title="지역 디지털 산업 생태계 실태조사" />
      <TableWrapper tableData={{ tableHeader, tableBody: fetchData }} boardType={boardType} loading={loading} fetchList={fetchList} />
    </Section>
  );
}
